export default __webpack_public_path__ + "static/media/Pablo Longo Elia.04063fb6.jpg";